import { Route } from '@angular/router';
import { ROUTE_PATH } from '../../routing/RoutePath.const';
import { PreventInIframeGuard } from '../../routing/prevent-in-iframe.guard';

export const publicPagesRoutes: Route[] = [
  {
    path: ROUTE_PATH.HOME,
    loadChildren: () =>
      import('./home-page/home-page.module').then((m) => m.HomePageModule),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.SALON_SEARCH_RESULT,
    loadChildren: () =>
      import('./salon-search-result-page/salon-search-result-page.module').then(
        (m) => m.SalonSearchResultPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.SALON_DETAILS,
    loadChildren: () =>
      import('./salon-details-page/salon-details-page.module').then(
        (m) => m.SalonDetailsPageModule
      ),
  },
  {
    path: ROUTE_PATH.SALON_BOOKING_CONFIG,
    loadChildren: () =>
      import(
        './salon-booking-config-page/salon-booking-config-page.module'
      ).then((m) => m.SalonBookingConfigPageModule),
  },
  {
    path: ROUTE_PATH.GOOGLE_SALON_DETAILS,
    loadChildren: () =>
      import(
        './google-salon-details-page/google-salon-details-page.module'
      ).then((m) => m.GoogleSalonDetailsPageModule),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.PUBLIC_APPOINTMENT_DETAILS,
    loadComponent: () =>
      import(
        './public-appointment-details-page/public-appointment-details-page.component'
      ).then((m) => m.PublicAppointmentDetailsPageComponent),
  },
  {
    path: ROUTE_PATH.RWG_CANCEL_REQUEST,
    loadChildren: () =>
      import('./rwg-cancel-request-page/rwg-cancel-request-page.module').then(
        (m) => m.RwgCancelRequestPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.IMPRINT,
    loadChildren: () =>
      import('./imprint-page/imprint-page.module').then(
        (m) => m.ImprintPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.PRIVACY_POLICY,
    loadChildren: () =>
      import('./privacy-policy-page/privacy-policy-page.module').then(
        (m) => m.PrivacyPolicyPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.TOP_SALONS,
    loadChildren: () =>
      import('./top-salons-page/top-salons-page.module').then(
        (m) => m.TopSalonsPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: ROUTE_PATH.TOP_SALONS_CITY,
    loadChildren: () =>
      import('./top-salons-city-page/top-salons-city-page.module').then(
        (m) => m.TopSalonsCityPageModule
      ),
    canActivate: [PreventInIframeGuard],
  },
  {
    path: '*',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.HOME,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.HOME,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_PATH.HOME,
  },
];
